import {
  AssessmentButton,
  AssessmentCheckboxRadio,
  InputField,
  Pagination,
  showToast,
  SkeletonList,
  TemplateSearch,
  TypeSelect,
} from "ui-components";
import Header from "../../../components/Assessment/Header/Header";
import Footer from "../../../components/Footer/Footer";
import DocIcon from "../../../utils/Images/DocIcon";
import DocxIcon from "../../../utils/Images/DocxIcon";
import PdfIcon from "../../../utils/Images/PdfIcon";
import "./VendorDocuments.scss";
import {
  copyText,
  getSplittedCdnUrl,
  scrollWindowTop,
} from "../../../utils/Common/Constant";
import DownArrow from "../../../utils/Images/DownArrow";
import { CommonEnums } from "../../../utils/Enums/CommonEnums";
import { useTranslation } from "react-i18next";
import BackArrow from "../../../utils/Images/BackArrow";
import { useEffect, useRef, useState } from "react";
import CustomModal from "../../../components/CustomModal/CustomModal";
import {
  getResourceDocument,
  getUploadedDocuments,
  partnerJobsList,
} from "../../../service/StaffAugumentation/StaffAugumentationApis";
import { useParams } from "react-router-dom";
import DownloadCVIcon from "../../../utils/Images/DownloadCVIcon";
import DataNotAvailable from "../../../utils/DataNotFound/DataNotAvailable";
import useDebounce from "../../../utils/Hooks/useDebounce";
import { reviewDocuments } from "../../../service/Settings/Settings";
import PngIcon from "../../../utils/Images/PngIcon";
import CircleCrossIcon from "../../../utils/Images/CircleCrossIcon";
import JPGIcon from "../../../utils/Images/JPGIcon";
import { handleDownloadEncryptFile } from "../../../utils/Common/VideoUploader";
import Loader from "../../../components/Loader/Loader";
import UserImage from "../../../utils/Images/UserImage";

const VendorDocuments = () => {
  const [resourceDoc, setResourceDoc] = useState<any[]>([]);
  const [search, setSearch] = useState<string>("");
  const [jobId, setJobId] = useState<string>("");
  const [resourceListLoading, setResourceListLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const resourceSearchDebounce = useDebounce(search, 500);
  const [reviewStatus, setReviewStatus] = useState<{ [key: string]: string }>(
    {},
  );
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [jobDocLoading, setJobDocLoading] = useState(false);
  const [contractDocLoading, setContractDocLoading] = useState(false);
  const [currentDocId, setCurrentDocId] = useState(0);
  const [jobDocId, setJobDocId] = useState(0);
  const [contractDocId, setContractDocId] = useState(0);
  const [remarkInput, setRemarkInput] = useState<{ [key: string]: string }>({});
  const [showRemarkField, setShowRemarkField] = useState<{
    [key: string]: boolean;
  }>({});
  const [closing, setClosing] = useState<{ [key: string]: boolean }>({});
  const [uploadDoc, setUploadDoc] = useState<any>([]);
  const [profileDetail, setProfileDetail] = useState<any>([]);
  const [partnerListLoading, setPartnerListLoading] = useState(false);
  const { t } = useTranslation();
  const [opendocumentSettingModal, setOpenDocumentSettingModal] = useState<any>(
    {
      data: {},
      isOpen: false,
    },
  );
  const [checkboxFilter, setCheckboxFilter] = useState<any>(
    CommonEnums.DOCUMENT_MANDATORY,
  );
  const [jobList, setJobList] = useState([]);
  const { partnerCompanyId } = useParams<{ partnerCompanyId: string | any }>();
  useEffect(() => {
    scrollWindowTop();
  }, []);

  // partners Uploaded documents api
  useEffect(() => {
    getUploadedDoc();
  }, []);
  const getUploadedDoc = async () => {
    setPartnerListLoading(true);
    try {
      const response = await getUploadedDocuments(partnerCompanyId);
      if (response?.status === 200) {
        setPartnerListLoading(false);
        setProfileDetail(response?.data?.companyDetails);
        setUploadDoc(response?.data?.partnerDocuments);
      } else {
        setPartnerListLoading(false);
      }
    } catch (error) {
      console.error(error);
    }
  };
  // resource Uploaded documents api
  const fetchDocs = async () => {
    setResourceListLoading(true);
    try {
      const res = await getResourceDocument(
        search,
        partnerCompanyId,
        jobId,
        currentPage,
        pageSize,
      );
      setTotalCount(res?.data?.totalCount);
      setResourceDoc(res?.data?.data || null);
    } catch (error) {
      console.error("Error fetching resource documents", error);
    } finally {
      setResourceListLoading(false);
    }
  };
  useEffect(() => {
    fetchDocs();
  }, [resourceSearchDebounce, jobId, currentPage, pageSize]);
  useEffect(() => {
    partnerJobsListAPi();
  }, []);
  // partnerJobsList APi
  const partnerJobsListAPi = async () => {
    const res = await partnerJobsList(partnerCompanyId);
    if (res?.status === 200) {
      const jobsOptions = await res?.data?.data?.map((item: any) => ({
        value: item?.jobId,
        label: item?.jobs?.title,
      }));
      setJobList(jobsOptions);
    }
  };

  // reviewDocument api
  const handleReview = async (
    status: "approved" | "rejected",
    staffAugumentationDocumentId: string,
    remark: string = "",
  ) => {
    try {
      const payload = {
        staffAugumentationDocumentId: [staffAugumentationDocumentId],
        status,
        remark: status === CommonEnums.STATUS_REJECTED ? remark : "",
      };

      const res = await reviewDocuments(payload);
      showToast(res?.customMessage, "success");

      // set active status for this document
      setReviewStatus((prev) => ({
        ...prev,
        [staffAugumentationDocumentId]: status,
      }));

      // hide remark field after saving
      setShowRemarkField((prev) => ({
        ...prev,
        [staffAugumentationDocumentId]: false,
      }));
    } catch (err) {
      console.error("Error reviewing document:", err);
    }
  };
  // Auto Focus in input field
  const inputRef = useRef<HTMLInputElement | null>(null);
  useEffect(() => {
    if (opendocumentSettingModal && inputRef.current) {
      inputRef.current.focus();
    }
  }, [opendocumentSettingModal]);
  return (
    <div>
      <Header />
      <div className="container-fluid vendorOnboardingWrapper">
        <div className="d-flex align-items-center justify-content-between gap-2 flex-wrap">
          <div className="headerContainer">
            <div
              className="backArrow"
              onClick={() => {
                history.back();
              }}
            >
              <BackArrow />
            </div>
            <div className="vendorNameImage">
              <div className="userImage">
                {profileDetail?.logo ? (
                  <img
                    src={profileDetail?.logo}
                    alt="image"
                    onError={(e) => {
                      e.currentTarget.onerror = null;
                      e.currentTarget.src = "/Images/defaultImage.png";
                    }}
                  />
                ) : (
                  <UserImage />
                )}
              </div>
              <span className="vendorName">
                {profileDetail?.displayName ?? "-"}
              </span>
            </div>
          </div>
          <div>
            <AssessmentButton
              className="lightBtn"
              onClick={() =>
                setOpenDocumentSettingModal({
                  data: {},
                  isOpen: true,
                })
              }
            >
              {t("SETTING.REQUEST_DOUCMENTS")}
            </AssessmentButton>
          </div>
        </div>
        <div className="documentContainer">
          <div className=" leftContainer">
            <div className="documentReviewSection">
              <h2 className="header">
                {t("EVENT.EVENT_AT_VENDOR_ONBOARDING")}
              </h2>
              {partnerListLoading ? (
                <div className=" ">
                  {Array.from({ length: 5 }).map((_, index) => (
                    <div className="mt-4" key={`skeleton-${index}`}>
                      <SkeletonList
                        numberOfTitles={1}
                        numberofTextLines={0}
                        titleSize={18}
                        textSize={12}
                        thumbnailHeight={80}
                        thumbnailWidth={50}
                        itemsGap={20}
                      />
                    </div>
                  ))}
                </div>
              ) : !uploadDoc?.length ? (
                <div className="minHeight60 d-flex align-items-center justify-content-center">
                  <DataNotAvailable text={t("CONTRACT.NO_DOCUMENT_UPLOADED")} />
                </div>
              ) : (
                <div className="documentApprovalSection">
                  {uploadDoc?.map((item: any, index: number) => (
                    <div
                      key={item.staffAugumentationDocumentId}
                      className="documentCard"
                    >
                      <div className="d-flex gap-2">
                        <div className="inlinePreviewContainer">
                          {item["documents.fileExtension"] ===
                          CommonEnums.EXTENSION_PDF ? (
                            <PdfIcon />
                          ) : item["documents.fileExtension"] ===
                            CommonEnums.EXTENSION_PNG ? (
                            <PngIcon />
                          ) : item["documents.fileExtension"] ===
                            CommonEnums.EXTENSION_DOC ? (
                            <DocIcon />
                          ) : item["documents.fileExtension"] ===
                            CommonEnums.EXTENSION_DOCX ? (
                            <DocxIcon />
                          ) : (
                            <JPGIcon />
                          )}
                        </div>
                        <div>
                          <h6>{item["documents.title"]}</h6>
                          <div className="attachInputDownload">
                            {downloadLoading && currentDocId === index ? (
                              <div className="d-flex gap-2">
                                <span className="pleaseWaitText">
                                  {t("GENERAL.PLEASE_WAIT")}
                                </span>
                                <div className="smallLoader">
                                  <Loader />
                                </div>
                              </div>
                            ) : (
                              <div
                                onClick={() => {
                                  setCurrentDocId(index);
                                  handleDownloadEncryptFile(
                                    getSplittedCdnUrl(
                                      item["documents.filePath"],
                                    ),
                                    setDownloadLoading,
                                    `${item["documents.fileName"]}`,
                                  );
                                }}
                              >
                                <div
                                  className="d-flex gap-2 linkStyle"
                                  title={item["documents.fileName"]}
                                >
                                  {item["documents.fileName"]}
                                  <div>
                                    <DownloadCVIcon />
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="actions">
                        {reviewStatus[item.staffAugumentationDocumentId] ===
                          CommonEnums.STATUS_APPROVED ||
                        item?.status === CommonEnums.STATUS_APPROVED ? (
                          <AssessmentButton className="statusText approved">
                            {t("SETTING.APPROVED")}
                          </AssessmentButton>
                        ) : reviewStatus[item.staffAugumentationDocumentId] ===
                            CommonEnums.STATUS_REJECTED ||
                          item?.status === CommonEnums.STATUS_REJECTED ? (
                          <AssessmentButton className="statusText rejected">
                            {t("VENDOR.REJECTED")}
                          </AssessmentButton>
                        ) : showRemarkField[
                            item.staffAugumentationDocumentId
                          ] ? (
                          <div
                            className={`remarkSec ${closing[item.staffAugumentationDocumentId] ? "fade-out" : "fade-in"}`}
                            onAnimationEnd={() => {
                              if (closing[item.staffAugumentationDocumentId]) {
                                setShowRemarkField((prev) => ({
                                  ...prev,
                                  [item.staffAugumentationDocumentId]: false,
                                }));
                                setClosing((prev) => ({
                                  ...prev,
                                  [item.staffAugumentationDocumentId]: false,
                                }));
                              }
                            }}
                          >
                            <div className="d-flex gap-1 mb-2">
                              <InputField
                                placeholder={t("SETTING.REMARK")}
                                value={
                                  remarkInput[
                                    item.staffAugumentationDocumentId
                                  ] || ""
                                }
                                onChange={(e: any) =>
                                  setRemarkInput((prev) => ({
                                    ...prev,
                                    [item.staffAugumentationDocumentId]: e,
                                  }))
                                }
                              />
                              <AssessmentButton
                                onClick={() =>
                                  handleReview(
                                    CommonEnums.STATUS_REJECTED,
                                    item.staffAugumentationDocumentId,
                                    remarkInput[
                                      item.staffAugumentationDocumentId
                                    ] || "",
                                  )
                                }
                                className="saveBtn whiteBtn"
                                disabled={
                                  !remarkInput[
                                    item.staffAugumentationDocumentId
                                  ]?.trim()
                                }
                              >
                                {t("GENERAL.SAVE")}
                              </AssessmentButton>
                              <AssessmentButton
                                className="closeBtn"
                                onClick={() =>
                                  setClosing((prev) => ({
                                    ...prev,
                                    [item.staffAugumentationDocumentId]: true,
                                  }))
                                }
                              >
                                <CircleCrossIcon />
                              </AssessmentButton>
                            </div>
                          </div>
                        ) : (
                          <>
                            <AssessmentButton
                              onClick={() =>
                                handleReview(
                                  CommonEnums.STATUS_APPROVED,
                                  item.staffAugumentationDocumentId,
                                )
                              }
                              className="approveBtn"
                            >
                              {t("GENERAL.APPROVE")}
                            </AssessmentButton>
                            <AssessmentButton
                              onClick={() =>
                                setShowRemarkField((prev) => ({
                                  ...prev,
                                  [item.staffAugumentationDocumentId]: true,
                                }))
                              }
                              className="rejectBtn"
                            >
                              {t("GENERAL.REJECT")}
                            </AssessmentButton>
                          </>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
          <div className="rightContainer">
            <div className="documentReviewSection">
              <div className="jobSelect">
                <div className="searchResource">
                  <TemplateSearch
                    onChange={(e: any) => {
                      setSearch(e);
                      setCurrentPage(1);
                    }}
                    placeholder={t("SETTING.SEARCH_RESOURCE")}
                    iconName="searchList"
                  />
                </div>
              </div>
              <div className="dropdown">
                <TypeSelect
                  options={jobList}
                  placeholder={t("GENERAL.JOB")}
                  value={jobId}
                  onChange={(e: any) => {
                    setJobId(e);
                    setCurrentPage(1);
                  }}
                />
                <div
                  className={`resetBtn ${!jobId && "resetDisable"}`}
                  onClick={() => setJobId("")}
                >
                  {t("GENERAL.RESET")}
                </div>
              </div>
              {resourceListLoading ? (
                <div className=" ">
                  {Array.from({ length: 5 }).map((_, index) => (
                    <div className="mt-4" key={`skeleton-${index}`}>
                      <SkeletonList
                        numberOfTitles={1}
                        numberofTextLines={0}
                        titleSize={18}
                        textSize={12}
                        thumbnailHeight={80}
                        thumbnailWidth={50}
                        itemsGap={20}
                      />
                    </div>
                  ))}
                </div>
              ) : !resourceDoc?.length ? (
                <div className="minHeight60 d-flex align-items-center justify-content-center">
                  <DataNotAvailable />
                </div>
              ) : (
                <div className="accordion" id="documentsAccordianParent">
                  <div>
                    {resourceDoc.map((doc: any, idx: number) => (
                      <div className="userSection" key={idx}>
                        <div className="accordion-item">
                          <h2
                            className="accordion-header"
                            id={`heading-${idx}`}
                          >
                            <button
                              className="accordion-button collapsed d-block"
                              type="button"
                              {...(doc?.contractDocuments?.documents.length >
                                0 ||
                              doc?.resourceDocuments?.documents.length > 0
                                ? {
                                    "data-bs-toggle": "collapse",
                                    "data-bs-target": `#collapse-${idx}`,
                                    "aria-expanded": "false",
                                    "aria-controls": `collapse-${idx}`,
                                  }
                                : {
                                    disabled: true,
                                  })}
                            >
                              <div className="userInfoContainer">
                                <div className="userInfo">
                                  <img src={doc?.profilePic} alt="image" />
                                  <h1>{doc?.fileExt}</h1>
                                  <div className="userDetails">
                                    <span className="userName">
                                      {doc?.displayName}
                                    </span>
                                    <span
                                      className="userEmail"
                                      onClick={() => copyText(doc?.email2Id)}
                                    >
                                      {doc?.email2Id}
                                    </span>
                                  </div>
                                </div>

                                {doc?.contractDocuments?.documents.length > 0 ||
                                doc?.resourceDocuments?.documents.length > 0 ? (
                                  <div className="accordianArrow">
                                    <DownArrow />
                                  </div>
                                ) : (
                                  <p className="noDocHeading">
                                    {t("CONTRACT.NO_DOCUMENT_UPLOADED")}
                                  </p>
                                )}
                              </div>
                            </button>
                          </h2>

                          <div
                            id={`collapse-${idx}`}
                            className="accordion-collapse collapse"
                            aria-labelledby={`heading-${idx}`}
                            data-bs-parent="#documentsAccordianParent"
                          >
                            <div className="accordion-body">
                              {doc?.resourceDocuments?.documents.length ? (
                                <div className="documentTypeSection">
                                  <h3 className="documentTypeHead">
                                    {t(
                                      "EVENT.EVENT_AT_START_OF_JOB_APPLICATION",
                                    )}
                                  </h3>
                                  {/* Document counts */}
                                  <div className="documentCount">
                                    <span>
                                      {t("CREATED_ASSESSMENT_TOTAL")} -{" "}
                                      {doc?.resourceDocuments?.totalCount}
                                    </span>
                                    <span>
                                      {t("SETTING.APPROVED")} -{" "}
                                      {doc?.resourceDocuments?.approvedCount}
                                    </span>
                                    <span>
                                      {t("VENDOR.REJECTED")} -{" "}
                                      {doc?.resourceDocuments?.rejectedCount}
                                    </span>
                                    <span>
                                      {t("VENDOR.PENDING")} -{" "}
                                      {
                                        doc?.resourceDocuments
                                          ?.reviewPendingCount
                                      }
                                    </span>
                                  </div>
                                  {doc?.resourceDocuments?.documents?.map(
                                    (file: any, fileIdx: number) => (
                                      <div
                                        key={fileIdx}
                                        className="documentCard"
                                      >
                                        <div className="d-flex gap-2">
                                          <div className="inlinePreviewContainer">
                                            {file?.fileExt ===
                                            CommonEnums.EXTENSION_PDF ? (
                                              <PdfIcon />
                                            ) : file?.fileExt ===
                                              CommonEnums.EXTENSION_PNG ? (
                                              <PngIcon />
                                            ) : file?.fileExt ===
                                              CommonEnums.EXTENSION_DOC ? (
                                              <DocIcon />
                                            ) : file?.fileExt ===
                                              CommonEnums.EXTENSION_DOCX ? (
                                              <DocxIcon />
                                            ) : (
                                              <JPGIcon />
                                            )}
                                          </div>

                                          <div>
                                            <h6>{file?.title}</h6>
                                            {jobDocLoading &&
                                            jobDocId === fileIdx ? (
                                              <div className="d-flex gap-2">
                                                <span className="pleaseWaitText">
                                                  {t("GENERAL.PLEASE_WAIT")}
                                                </span>
                                                <div className="smallLoader">
                                                  <Loader />
                                                </div>
                                              </div>
                                            ) : (
                                              <div
                                                onClick={() => {
                                                  setJobDocId(fileIdx);
                                                  handleDownloadEncryptFile(
                                                    getSplittedCdnUrl(
                                                      file?.filePath,
                                                    ),
                                                    setJobDocLoading,
                                                    file?.fileName,
                                                  );
                                                }}
                                              >
                                                <div
                                                  className="d-flex gap-2 linkStyle"
                                                  title={file?.fileName}
                                                >
                                                  {file?.fileName}
                                                  <div>
                                                    <DownloadCVIcon />
                                                  </div>
                                                </div>
                                              </div>
                                            )}
                                          </div>
                                        </div>

                                        <div className="actions">
                                          {reviewStatus[
                                            file.staffAugumentationDocumentId
                                          ] === CommonEnums.STATUS_APPROVED ||
                                          file?.status ===
                                            CommonEnums.STATUS_APPROVED ? (
                                            <AssessmentButton className="statusText approved">
                                              {t("SETTING.APPROVED")}
                                            </AssessmentButton>
                                          ) : reviewStatus[
                                              file.staffAugumentationDocumentId
                                            ] === CommonEnums.STATUS_REJECTED ||
                                            file?.status ===
                                              CommonEnums.STATUS_REJECTED ? (
                                            <AssessmentButton className="statusText rejected">
                                              {t("VENDOR.REJECTED")}
                                            </AssessmentButton>
                                          ) : showRemarkField[
                                              file.staffAugumentationDocumentId
                                            ] ? (
                                            <div
                                              className={`remarkSec ${closing[file.staffAugumentationDocumentId] ? "fade-out" : "fade-in"}`}
                                              onAnimationEnd={() => {
                                                if (
                                                  closing[
                                                    file
                                                      .staffAugumentationDocumentId
                                                  ]
                                                ) {
                                                  setShowRemarkField(
                                                    (prev) => ({
                                                      ...prev,
                                                      [file.staffAugumentationDocumentId]: false,
                                                    }),
                                                  );
                                                  setClosing((prev) => ({
                                                    ...prev,
                                                    [file.staffAugumentationDocumentId]: false,
                                                  }));
                                                }
                                              }}
                                            >
                                              <div className="d-flex gap-1 mb-2">
                                                <InputField
                                                  placeholder={t(
                                                    "SETTING.REMARK",
                                                  )}
                                                  value={
                                                    remarkInput[
                                                      file
                                                        .staffAugumentationDocumentId
                                                    ] || ""
                                                  }
                                                  onChange={(e: any) =>
                                                    setRemarkInput((prev) => ({
                                                      ...prev,
                                                      [file.staffAugumentationDocumentId]:
                                                        e,
                                                    }))
                                                  }
                                                />
                                                <AssessmentButton
                                                  onClick={() =>
                                                    handleReview(
                                                      CommonEnums.STATUS_REJECTED,
                                                      file.staffAugumentationDocumentId,
                                                      remarkInput[
                                                        file
                                                          .staffAugumentationDocumentId
                                                      ] || "",
                                                    )
                                                  }
                                                  className="saveBtn whiteBtn"
                                                  disabled={
                                                    !remarkInput[
                                                      file
                                                        .staffAugumentationDocumentId
                                                    ]?.trim()
                                                  }
                                                >
                                                  {t("GENERAL.SAVE")}
                                                </AssessmentButton>
                                                <AssessmentButton
                                                  className="closeBtn"
                                                  onClick={() =>
                                                    setClosing((prev) => ({
                                                      ...prev,
                                                      [file.staffAugumentationDocumentId]: true,
                                                    }))
                                                  }
                                                >
                                                  <CircleCrossIcon />
                                                </AssessmentButton>
                                              </div>
                                            </div>
                                          ) : (
                                            <>
                                              <AssessmentButton
                                                onClick={() =>
                                                  handleReview(
                                                    CommonEnums.STATUS_APPROVED,
                                                    file.staffAugumentationDocumentId,
                                                  )
                                                }
                                                className="approveBtn"
                                              >
                                                {t("GENERAL.APPROVE")}
                                              </AssessmentButton>
                                              <AssessmentButton
                                                onClick={() =>
                                                  setShowRemarkField(
                                                    (prev) => ({
                                                      ...prev,
                                                      [file.staffAugumentationDocumentId]: true,
                                                    }),
                                                  )
                                                }
                                                className="rejectBtn"
                                              >
                                                {t("GENERAL.REJECT")}
                                              </AssessmentButton>
                                            </>
                                          )}
                                        </div>
                                      </div>
                                    ),
                                  )}
                                </div>
                              ) : (
                                ""
                              )}

                              {doc?.contractDocuments?.documents.length ? (
                                <div className="documentTypeSection">
                                  <h3 className="documentTypeHead">
                                    {t(
                                      "EVENT.EVENT_AT_START_OF_CONTRACT_CREATION",
                                    )}
                                  </h3>
                                  {/* Document counts */}
                                  <div className="documentCount">
                                    <span>
                                      {t("CREATED_ASSESSMENT_TOTAL")} -{" "}
                                      {doc?.contractDocuments?.totalCount}
                                    </span>
                                    <span>
                                      {t("SETTING.APPROVED")} -{" "}
                                      {doc?.contractDocuments?.approvedCount}
                                    </span>
                                    <span>
                                      {t("VENDOR.REJECTED")} -{" "}
                                      {doc?.contractDocuments?.rejectedCount}
                                    </span>
                                    <span>
                                      {t("VENDOR.PENDING")} -{" "}
                                      {
                                        doc?.contractDocuments
                                          ?.reviewPendingCount
                                      }
                                    </span>
                                  </div>
                                  {doc?.contractDocuments?.documents.map(
                                    (file: any, fileIdx: number) => (
                                      <div
                                        key={fileIdx}
                                        className="documentCard"
                                      >
                                        <div className="d-flex gap-2">
                                          <div className="inlinePreviewContainer">
                                            {file?.fileExt ===
                                            CommonEnums.EXTENSION_PDF ? (
                                              <PdfIcon />
                                            ) : file?.fileExt ===
                                              CommonEnums.EXTENSION_PNG ? (
                                              <PngIcon />
                                            ) : file?.fileExt ===
                                              CommonEnums.EXTENSION_DOC ? (
                                              <DocIcon />
                                            ) : file?.fileExt ===
                                              CommonEnums.EXTENSION_DOCX ? (
                                              <DocxIcon />
                                            ) : (
                                              <JPGIcon />
                                            )}
                                          </div>

                                          <div>
                                            <h6>{file?.title}</h6>
                                            {contractDocLoading &&
                                            contractDocId === fileIdx ? (
                                              <div className="d-flex gap-2">
                                                <span className="pleaseWaitText">
                                                  {t("GENERAL.PLEASE_WAIT")}
                                                </span>
                                                <div className="smallLoader">
                                                  <Loader />
                                                </div>
                                              </div>
                                            ) : (
                                              <div
                                                onClick={() => {
                                                  setContractDocId(fileIdx);
                                                  handleDownloadEncryptFile(
                                                    getSplittedCdnUrl(
                                                      file?.filePath,
                                                    ),
                                                    setContractDocLoading,
                                                    file?.fileName,
                                                  );
                                                }}
                                              >
                                                <div
                                                  className="d-flex gap-2 linkStyle"
                                                  title={file?.fileName}
                                                >
                                                  {file?.fileName}
                                                  <div>
                                                    <DownloadCVIcon />
                                                  </div>
                                                </div>
                                              </div>
                                            )}
                                          </div>
                                        </div>

                                        <div className="actions">
                                          {reviewStatus[
                                            file.staffAugumentationDocumentId
                                          ] === CommonEnums.STATUS_APPROVED ||
                                          file?.status ===
                                            CommonEnums.STATUS_APPROVED ? (
                                            <AssessmentButton className="statusText approved">
                                              {t("SETTING.APPROVED")}
                                            </AssessmentButton>
                                          ) : reviewStatus[
                                              file.staffAugumentationDocumentId
                                            ] === CommonEnums.STATUS_REJECTED ||
                                            file?.status ===
                                              CommonEnums.STATUS_REJECTED ? (
                                            <AssessmentButton className="statusText rejected">
                                              {t("VENDOR.REJECTED")}
                                            </AssessmentButton>
                                          ) : showRemarkField[
                                              file.staffAugumentationDocumentId
                                            ] ? (
                                            <div
                                              className={`remarkSec ${closing[file.staffAugumentationDocumentId] ? "fade-out" : "fade-in"}`}
                                              onAnimationEnd={() => {
                                                if (
                                                  closing[
                                                    file
                                                      .staffAugumentationDocumentId
                                                  ]
                                                ) {
                                                  setShowRemarkField(
                                                    (prev) => ({
                                                      ...prev,
                                                      [file.staffAugumentationDocumentId]: false,
                                                    }),
                                                  );
                                                  setClosing((prev) => ({
                                                    ...prev,
                                                    [file.staffAugumentationDocumentId]: false,
                                                  }));
                                                }
                                              }}
                                            >
                                              <div className="d-flex gap-1 mb-2">
                                                <InputField
                                                  placeholder={t(
                                                    "SETTING.REMARK",
                                                  )}
                                                  value={
                                                    remarkInput[
                                                      file
                                                        .staffAugumentationDocumentId
                                                    ] || ""
                                                  }
                                                  onChange={(e: any) =>
                                                    setRemarkInput((prev) => ({
                                                      ...prev,
                                                      [file.staffAugumentationDocumentId]:
                                                        e,
                                                    }))
                                                  }
                                                />
                                                <AssessmentButton
                                                  onClick={() =>
                                                    handleReview(
                                                      CommonEnums.STATUS_REJECTED,
                                                      file.staffAugumentationDocumentId,
                                                      remarkInput[
                                                        file
                                                          .staffAugumentationDocumentId
                                                      ] || "",
                                                    )
                                                  }
                                                  className="saveBtn whiteBtn"
                                                  disabled={
                                                    !remarkInput[
                                                      file
                                                        .staffAugumentationDocumentId
                                                    ]?.trim()
                                                  }
                                                >
                                                  {t("GENERAL.SAVE")}
                                                </AssessmentButton>

                                                <AssessmentButton
                                                  className="closeBtn"
                                                  onClick={() =>
                                                    setClosing((prev) => ({
                                                      ...prev,
                                                      [file.staffAugumentationDocumentId]: true,
                                                    }))
                                                  }
                                                >
                                                  <CircleCrossIcon />
                                                </AssessmentButton>
                                              </div>
                                            </div>
                                          ) : (
                                            <>
                                              <AssessmentButton
                                                onClick={() =>
                                                  handleReview(
                                                    CommonEnums.STATUS_APPROVED,
                                                    file.staffAugumentationDocumentId,
                                                  )
                                                }
                                                className="approveBtn"
                                              >
                                                {t("GENERAL.APPROVE")}
                                              </AssessmentButton>
                                              <AssessmentButton
                                                onClick={() =>
                                                  setShowRemarkField(
                                                    (prev) => ({
                                                      ...prev,
                                                      [file.staffAugumentationDocumentId]: true,
                                                    }),
                                                  )
                                                }
                                                className="rejectBtn"
                                              >
                                                {t("GENERAL.REJECT")}
                                              </AssessmentButton>
                                            </>
                                          )}
                                        </div>
                                      </div>
                                    ),
                                  )}
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              <div>
                <Pagination
                  className="pagination-bar"
                  currentPage={currentPage}
                  totalCount={totalCount > pageSize ? totalCount : 0}
                  pageSize={pageSize}
                  onPageChange={(page: number) => setCurrentPage(page)}
                  ofLabel={t("GENERAL.OF")}
                  resultLabel={t("GENERAL.RESULTS")}
                  setPageSize={setPageSize}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <CustomModal
        className="documentSettingModal"
        isCrossBtn={true}
        handleClose={() =>
          setOpenDocumentSettingModal({ data: {}, isOpen: false })
        }
        show={opendocumentSettingModal.isOpen}
        isHeaderVisible={false}
        isFooterVisible={false}
      >
        <div className="documentSetting">
          <div className="documentSettingTitle">
            {t("SETTING.REQUEST_DOUCMENTS")}
          </div>
          <div className="userInputSec">
            <span className="titleLabel">{t("GENERAL.TITLE")}</span>
            <div className="fields">
              <div className="input">
                <InputField
                  additionalProps={{
                    ref: (el: HTMLInputElement) => {
                      inputRef.current = el;
                    },
                  }}
                />
              </div>
              <div className="filterWork">
                <div
                  className="checkboxWithLabel"
                  onClick={() => {
                    setCheckboxFilter(CommonEnums.DOCUMENT_MANDATORY);
                  }}
                >
                  <AssessmentCheckboxRadio
                    type="radio"
                    checked={checkboxFilter === CommonEnums.DOCUMENT_MANDATORY}
                  />
                  <p className="radioCheckLabel">{t("SETTING.MANDATORY")}</p>
                </div>
                <div
                  className="checkboxWithLabel"
                  onClick={() => {
                    setCheckboxFilter(CommonEnums.DOCUMENT_OPTIONAL);
                  }}
                >
                  <AssessmentCheckboxRadio
                    type="radio"
                    checked={checkboxFilter === CommonEnums.DOCUMENT_OPTIONAL}
                  />
                  <p className="radioCheckLabel">{t("SETTING.OPTIONAL")}</p>
                </div>
              </div>
              <div className="saveBtn">
                <AssessmentButton
                  onClick={() => {
                    setOpenDocumentSettingModal({ data: {}, isOpen: false });
                  }}
                >
                  {t("GENERAL.SAVE")}
                </AssessmentButton>
              </div>
            </div>
          </div>
        </div>
      </CustomModal>
      <Footer />
    </div>
  );
};

export default VendorDocuments;
